import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counter"]

  connect() {
    this.animated = false
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animated) {
            this.animated = true
            this.animateCounters()
          }
        })
      },
      { threshold: 0.3 }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  animateCounters() {
    this.counterTargets.forEach((el) => {
      const target = parseInt(el.dataset.target, 10)
      const suffix = el.dataset.suffix || ""
      const duration = 2000
      const start = performance.now()

      const step = (now) => {
        const elapsed = now - start
        const progress = Math.min(elapsed / duration, 1)
        const eased = 1 - Math.pow(1 - progress, 3)
        const current = Math.floor(eased * target)
        el.textContent = current + suffix
        if (progress < 1) requestAnimationFrame(step)
      }

      requestAnimationFrame(step)
    })
  }
}
